import { render, staticRenderFns } from "./TaskKanbanBoard.vue?vue&type=template&id=067cd30a&scoped=true&"
import script from "./TaskKanbanBoard.vue?vue&type=script&lang=js&"
export * from "./TaskKanbanBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskKanbanBoard.vue?vue&type=style&index=0&id=067cd30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067cd30a",
  null
  
)

export default component.exports